export type DesignLicenseStatusTypes =
  | 'needs_changes'
  | 'will_require_approval'
  | 'approval_required'
  | 'marks_in_review'
  | 'design_duplicate'
  | 'marks_pre_approved'
  | 'marks_approved'
  | 'no_marks';

export type HqLicensingStatusTypes =
  | 'needs_changes'
  | 'will_require_approval'
  | 'pre_approved'
  | 'approved'
  | 'licensing_review';

export type PartialLicensingStatusTypes =
  | 'needs_changes'
  | 'will_require_approval'
  | 'approval_required'
  | 'marks_in_review'
  | 'marks_pre_approved'
  | 'marks_approved';

export const DESIGN_DONE_OVERLAY_TEXT = 'Select the Design You Want to Add as a Color Option';

export const ORIGINAL_VERSION = 'Original Version';

export const DESIGN_TOOL_DISABLED_MESSAGE =
  "Sorry! This design can't be edited in the Design Tool yet. Please click on 'Request Revision' to tell us the edits. Our artists will revise it for free.";

export const MOB_DESIGN_TOOL_DISABLED_MESSAGE =
  "Sorry! This design can't be edited in the Design Tool yet. Please click on 'Request Revision' button on the left to tell us the edits. Our artists will revise it for free.";
